import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoKm: CultureInfo = {
  name: 'km',
  displayName: 'Khmer',
  iso3LanguageCode: 'khm',
  iso2LanguageCode: 'km',
  ietfLanguageTag: 'km',
  parent: null
};
